import React, { useEffect, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

export default function MeshGradient() {
  const { scrollY } = useScroll();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const y1 = useTransform(scrollY, [0, 1000], [0, 200]);
  const y2 = useTransform(scrollY, [0, 1000], [0, -200]);
  const y3 = useTransform(scrollY, [0, 1000], [0, 100]);

  if (isMobile) {
    return (
      <div className="fixed inset-0 -z-10">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_rgba(124,58,237,0.15),_transparent_35%),_radial-gradient(circle_at_top_left,_rgba(99,102,241,0.15),_transparent_45%),_radial-gradient(circle_at_bottom_left,_rgba(124,58,237,0.2),_transparent_25%)]" />
      </div>
    );
  }

  return (
    <div className="fixed inset-0 -z-10 overflow-hidden">
      <motion.div 
        style={{ y: y1 }}
        className="absolute -top-1/2 -right-1/2 w-full h-full bg-[radial-gradient(circle,_rgba(124,58,237,0.15)_0%,_transparent_60%)]"
      />
      <motion.div 
        style={{ y: y2 }}
        className="absolute -top-1/2 -left-1/2 w-full h-full bg-[radial-gradient(circle,_rgba(99,102,241,0.15)_0%,_transparent_60%)]"
      />
      <motion.div 
        style={{ y: y3 }}
        className="absolute -bottom-1/2 left-1/4 w-full h-full bg-[radial-gradient(circle,_rgba(124,58,237,0.2)_0%,_transparent_60%)]"
      />
    </div>
  );
}
